/**
 * Utilidades para construir URLs correctamente.
 * Desarrollo: siempre .smarty.local y puerto 8080 (127.0.0.1 en hosts).
 * Producción: siempre .smarty.lat sin puerto (HTTPS).
 */

import { isDevelopmentHost } from '@/config/app-domains.config';

/**
 * Obtiene la URL base según el entorno.
 * - Desarrollo: convierte .smarty.lat → .smarty.local y usa http con puerto 8080.
 * - Producción: usa el dominio tal cual con https (sin puerto).
 */
export function getBaseUrl(domain: string = 'web.smarty.lat'): string {
  if (typeof window === 'undefined') {
    return `https://${domain}`;
  }

  if (isDevelopmentHost()) {
    // En desarrollo: usar siempre .local y puerto 8080 para no mezclar con producción
    const devDomain = domain.replace(/\.smarty\.lat$/i, '.smarty.local');
    return `http://${devDomain}:8080`;
  }

  return `https://${domain}`;
}

/**
 * Construye una URL completa con ruta y parámetros.
 * En desarrollo el dominio se convierte a .smarty.local:8080 automáticamente.
 */
export function buildUrl(
  domain: string = 'web.smarty.lat',
  path: string = '/',
  params?: Record<string, string>
): string {
  const baseUrl = getBaseUrl(domain);
  const fullPath = path.startsWith('/') ? path : `/${path}`;
  
  let url = `${baseUrl}${fullPath}`;
  
  if (params && Object.keys(params).length > 0) {
    const searchParams = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
      if (value) {
        searchParams.append(key, value);
      }
    });
    url += `?${searchParams.toString()}`;
  }
  
  return url;
}
